// Create isPrometheusAvailable function

import { Entity } from '@backstage/catalog-model';
import { METRIC_INSTANCE, METRIC_TYPE } from '../constants';

export const isMetricsAvailable = (entity: Entity) => {
    return Boolean(entity?.metadata.annotations?.[METRIC_INSTANCE]);
}

export const getMetricInstance = (entity: Entity) => {
    return entity?.metadata.annotations?.[METRIC_INSTANCE];
}

export const getMetricType = (entity: Entity) => {
    return entity?.metadata.annotations?.[METRIC_TYPE];
}
    